interface IInfoArea {
    title: string,
    value: string | number
}

const InfoArea = ({ title, value }: IInfoArea) => {
    return (
        <div className='flex items-center w-full'>
            <p className='w-[170px] text-lg shrink-0'>{title}</p>
            <div className='flex-1 bg-[#F8F8FA] px-6 py-3 rounded min-h-12'>
                {value && value}
            </div>
        </div>
    )
}

export default InfoArea